window.addEventListener('DOMContentLoaded', function () {
  // requer gsap.min.js + ScrollTrigger.min.js
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  const pin = document.querySelector('.pc-pin');
  const track = document.querySelector('.pc-track');
  // usa a mesma lógica original: header vem de um escopo global
  const headerOffset = header ? header.offsetHeight + 20 : 0;

  if (!pin || !track) return;

  ScrollTrigger.matchMedia({
    // DESKTOP / LARGE SCREENS: mantém o comportamento original (pinned + horizontal)
    '(min-width: 992px)': () => {
      // total horizontal distance = track width - viewport width
      const getDistance = () => track.scrollWidth - window.innerWidth;

      // timeline original com ScrollTrigger embutido
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: pin,
          pin: true,
          scrub: true,
          start: `top+=-${headerOffset} top`,
          end: () => '+=' + getDistance(),
          invalidateOnRefresh: true,
        },
      });

      // animação horizontal do trilho
      tl.to(
        track,
        {
          x: () => -getDistance(),
          ease: 'none',
        },
        0,
      );

      // cards com efeito de escala/opacidade, usando containerAnimation = tl
      const cards = gsap.utils.toArray('.pc-card');
      const cardTriggers = [];

      cards.forEach((card) => {
        const trig = ScrollTrigger.create({
          trigger: card,
          containerAnimation: tl,
          start: 'left center',
          end: 'right right',
          // onUpdate: (self) => {
          //   const t = Math.abs(self.progress - 0.5) * 2; // 0 no centro, 1 nas bordas
          //   const s = 1 - 0.08 * t;
          //   const o = 1 - 0.4 * t;
          //   card.style.transform = `scale(${s})`;
          //   card.style.opacity = o.toFixed(3);
          // },
        });
        cardTriggers.push(trig);
      });

      // cleanup quando sai desse breakpoint
      return () => {
        if (tl.scrollTrigger) {
          tl.scrollTrigger.kill();
        }
        tl.kill();
        cardTriggers.forEach((t) => t.kill());
        cards.forEach((card) => {
          card.style.transform = '';
          card.style.opacity = '';
        });
      };
    },

    // MOBILE / SMALL SCREENS: nenhum pin, nenhuma animação — só layout vertical via CSS
    '(max-width: 991px)': () => {
      // intencionalmente vazio: sem ScrollTriggers no mobile
      return () => {
        // nada para limpar
      };
    },
  });

  // mantém distâncias corretas em resize (somente impacta o desktop, via matchMedia)
  window.addEventListener('resize', () => {
    ScrollTrigger.refresh();
  });
});
